export default {
  tips: {
    google: 'Chưa cài đặt trình xác thực google, vui lòng cài đặt',
    tip: 'Không phải merchant, không thể rút tiền'
  },
  label: {
    withdrawalAmountTotal: 'Tổng tiền rút',
    handlingFeeTotal: 'tổng phí rút tiền',
    agentNo: 'tài khoản đại lý',
    account: 'chủ tài khoản',
    actualTransferAmount: 'thực tế nhận được ',
    bankName: 'tên ngân hàng',
    bankNo: 'số tài khoản',
    bankCode: "Mã ngân hàng",
    createAcct: 'người tạo',
    createTime: 'thời gian tạo',
    handlingFee: 'phí',
    bankLoginAccount: 'Đăng nhập tài khoản',
    bankLoginPwd: 'Mật khẩu đăng nhập',
    merchatName: 'Tên merchant',
    asyncStatus: {
      label: "Trạng thái thông báo",
      status: {
        "0": "Chưa",
        "1": "Thành công",
        "-1": "Thất bại"
      }
    },
    payoutFeeCount: "Tổng phí thanh toán",
    payoutAmountCount: "Tổng số tiền thanh toán",
    receiver: "Tên người nhận tiền",
    paymentBank: "Ngân hàng thanh toán",
    paymentName: "Tên người thanh toán",
    paymentAccount: "Số tài khoản thanh toán",
    applyTime: "Ngày nộp đơn",
    notifyTime: "Thông báo ngày",
    agentFee: "Phí cơ quan",
    id: 'mã chính ID',
    merchatNo: 'Tài khoản merchant',
    remark: 'ghi chú',
    reviewer: 'người duyệt',
    type: 'loại',
    updateAcct: 'người update',
    updateTime: 'thời gian update',
    withdrawalAmount: 'số tiền',
    withdrawalNo: 'mã giao dịch rút tiền',
    withdrawalStatus: 'trạng thái',
    action: 'thao tác',
    totalBalance: 'Tổng số dư có sẵn để thanh toán',
    payoutSumAmount: 'Tổng số tiền xuất khoản',

    systemOrderNo: "Số thứ tự hệ thống",
    amount: "Số tiền phải trả",
    accountBankCode: "Mã ngân hàng thanh toán",
    accountNumber: "Số tài khoản rút tiền",
    accountName: "Tên người trả tiền",
    description: "nội dung",
    beneficiaryName: "Tên người thụ hưởng",
    payTime: "Thời gian thanh toán",
    payAmount: "Số tiền thành công",
    cashType: {
      label: "Loại quỹ",
      status: [
        { label: "Chuyển khoản", value: "+" },
        { label: "Chuyển ra ngoài", value: "-" },
      ]
    },
    orderNo: "Số đơn đặt hàng của người bán",
    merchantNo: "Số người bán chính thức",
    merchantName: "Tên của thương gia",
    payoutType1:"Thanh toan tự động",
    payoutType2:"Thanh toán thủ công",
    paymentType:"Hình thức thanh toán",
    paymentFixedFeeTatal:'Tổng phí cố định thanh toán',
    autoSuccessAmount:'Số tiền thành công tự động',
    manualSuccessAmount:'Số lượng đơn hàng thành công',
  },
  rules: {
    bankNo: {
      required: 'số tài khoản không được để trống',
      type: 'Số tài khoản phải là định dạng số',
      min: 'Độ dài phải lớn hơn 9'
    },
    bankName: {
      required: 'Tên ngân hàng không được để trống',
    },
    depositor: {
      required: 'Chủ tài khoản ngân hàng không được để trống',
    },
    cardNumber: {
      required: 'Không được để trống số thẻ ngân hàng',
    },
    bankCode: {
      required: 'Không được để trống mã ngân hàng',
    },
    loginName: {
      required: 'Tên người dùng đăng nhập ngân hàng không được để trống',
    },
    otp: {
      required: 'Vui lòng nhập mã giao dịch từ 6 đến 8 chữ số',
    },
    accountName: {
      required: 'Tên người nhận tiền không được để trống',
    },
    loginAccount: {
      required: 'Tài khoản đăng nhập không được để trống',
    },
    password: {
      required: 'Mật khẩu đăng nhập không được để trống',
    },
    accountstatus: {
      required: 'Trạng thái tài khoản không được để trống',
    },
  },
  orderDescription: 'Mô tả đơn hàng',
  withdrawalInterval: 'Khoảng thời gian rút tiền',
  bankInfo_label1: 'Giới hạn số lần thanh toán mỗi ngày',
  bankInfo_label2: 'Số tiền thanh toán tối thiểu',
  bankInfo_label3: 'Số tiền thanh toán tối đa',
  bankInfo_label4: 'Tổng số lần trong ngày',
  batchSettings: 'Cài đặt hàng loạt'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/withdraw.js